import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import Styles from './MenuItem.module.scss'
import { useDocStore } from 'stores/DocStore'
import { CollabItemsFilter } from 'stores/CollabItemsFilters'
import { MinimalUserSerializerUser } from 'types'
import Avatar from 'common/Avatar/Avatar'
import { getInitials } from 'utils'
import { ReactNode } from 'react'
import { Counter, CounterSize, CounterVariant } from 'blaze-ui/Counter/Counter'
import { Check2 } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  filter: CollabItemsFilter
  onClick: () => void
  user?: MinimalUserSerializerUser
  selected?: boolean
  icon?: ReactNode
  itemsCount?: number
}

export const MenuItem = observer(({ filter, onClick, user, selected = false, icon, itemsCount }: Props) => {
  const docStore = useDocStore()
  const isSelected = docStore.filters.activeKeys.has(filter.key) || selected
  const count =
    itemsCount ||
    (user ? docStore.filteredActiveNonUserCollabItems : docStore.filteredActiveCollabItems).filter(filter.fn).length

  return (
    <div
      aria-label={filter.key}
      key={filter.key}
      className={cx(Styles.filterItemContainer, {
        [Styles.disabled]: count === 0,
        [Styles.selected]: isSelected,
      })}
    >
      <Text variant="smallList">
        <div className={Styles.filterItem} key={filter.key} onClick={onClick}>
          {filter.facet === 'user' ? (
            <div className={Styles.label}>
              <Avatar
                size={20}
                url={user?.avatar_url}
                label={getInitials(user?.display_name || 'Anonymous User')}
                className={Styles.avatar}
              />
              <div className={Styles.userName}>{user?.display_name || 'Anonymous User'}</div>
            </div>
          ) : (
            <div className={Styles.label}>
              {icon}
              {filter.label}
            </div>
          )}
          <div className={Styles.counterAndCheck}>
            <Counter
              variant={isSelected ? CounterVariant.Secondary : CounterVariant.Primary}
              size={CounterSize.sm}
              count={count}
            />
            {isSelected && <Check2 />}
          </div>
        </div>
      </Text>
    </div>
  )
})
